'use client';

import * as a$1 from "react";
import p from "../lib/IconBase.es.js";
import e from "../defs/Broadcast.es.js";
const a = a$1.forwardRef((r, t) => /* @__PURE__ */ a$1.createElement(p, { ref: t, ...r, weights: e }));
a.displayName = "BroadcastIcon";
const n = a;
export {
  n as Broadcast,
  a as BroadcastIcon
};
